(function() {
  var BaseStep, FieldsUploadHandler,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  BaseStep = App.loadClass("grower::viewmodels/fields/add/steps/BaseStep");

  FieldsUploadHandler = App.loadClass("grower::handlers/fields/Fields_Upload_Handler");

  exports.UploadStart = (function(superClass) {
    extend(UploadStart, superClass);

    function UploadStart() {
      return UploadStart.__super__.constructor.apply(this, arguments);
    }

    UploadStart.prototype.afterSet = function() {
      var sub;
      sub = this.parent.handler.createSubHandler(FieldsUploadHandler);
      if (sub) {
        sub.init();
        return sub.loadLayout();
      }
    };

    return UploadStart;

  })(BaseStep);

}).call(this);
